<div class="sum-overview">
  <div class="sum-entry">
    <h4>{{sumPerLiter | number:'1.2-2'}}</h4><br/>
    <h3>{{'cost.currency_per_liter' | translate}}</h3>

  </div>
</div>
